import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_736b5617-324a-4027-a0b5-949393e5cf90/artifacts/te4le6nd_Untitled%20design.png";

export default function VideoViewerPage() {
  const { token } = useParams();
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API_URL}/api/v/${token}/meta`)
      .then((r) => setMeta(r.data))
      .catch((e) => setError(e.response?.data?.detail || 'Video not found'));
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen bg-[#0F172A] text-white flex items-center justify-center px-6">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-2">Video not available</h1>
          <p className="text-white/70 text-sm">{error}</p>
        </div>
      </div>
    );
  }
  if (!meta) {
    return (
      <div className="min-h-screen bg-[#0F172A] text-white flex items-center justify-center">
        <Loader2 size={28} className="animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0F172A] text-white" data-testid="video-viewer-page">
      <header className="container-custom py-4 flex items-center justify-between">
        <a href="/" className="inline-flex items-center gap-2">
          <img src={LOGO_URL} alt="DCA Enterprises Inc." className="h-8 w-auto" />
          <span className="text-sm font-bold tracking-wider text-white/80">DCA ENTERPRISES INC.</span>
        </a>
        <a href="/free-jumpstart-session" className="text-xs font-bold text-[#F97316] hover:text-[#FB923C]">Book a Free Session →</a>
      </header>

      <main className="container-custom pb-12 pt-2">
        <div className="max-w-4xl mx-auto">
          <div className="bg-black rounded-xl overflow-hidden shadow-2xl mb-5">
            <video
              src={`${API_URL}${meta.stream_url}`}
              controls
              autoPlay
              className="w-full aspect-video"
              data-testid="video-viewer-player"
            />
          </div>
          <h1 className="text-2xl lg:text-3xl font-bold mb-2" data-testid="video-viewer-title">{meta.title}</h1>
          {meta.description && (
            <p className="text-white/75 leading-relaxed mb-4" data-testid="video-viewer-description">{meta.description}</p>
          )}
          <p className="text-xs text-white/50">
            Recorded {meta.created_at ? new Date(meta.created_at).toLocaleString() : ''} · DCA Enterprises Inc.
          </p>
        </div>
      </main>
    </div>
  );
}
